/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';
import './ComponenetsStyles/BrandTracking.css';
import '../../index.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { ordersDataState, userDataState } from '../../main';
import {
  downloadApplications,
  faxTrackingData,
  sendFaxTracking,
} from '../../utils/sfFunctions';
import { Button, Stack, Typography } from '@mui/material';
import {
  collection,
  doc,
  DocumentData,
  getDocs,
  query,
  updateDoc,
  where,
} from 'firebase/firestore';
import TrackingButton from './TrackingButton';
import { db } from '../../firebase-setup/firebase';
import { navigateWithQuery } from '../../utils/utilFuntions';
import { docInfo } from '../../utils/types';
import { useCollection } from 'react-firebase-hooks/firestore';

function BrandTracking({
  medicationList = [],
  healthcareData,
}: {
  medicationList: DocumentData[] | null;
  healthcareData: DocumentData | null;
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { userData } = useContext(userDataState);
  const { ordersData } = useContext(ordersDataState);
  const [step, setStep] = useState<number>(0);
  const [screen, setScreen] = useState(0);
  const applicationMeds: string[] = [];
  const faxTrackingMeds: faxTrackingData[] = [];
  const [clientExtraDetails, setClientExtraDetails] = useState<
    {
      [key: string]: string;
    }[]
  >([]);
  const [medicareExtraDetails, loadingMedicareExtraDetails] = useCollection(
    collection(db, 'medicareExtraDetails'),
    {
      snapshotListenOptions: { includeMetadataChanges: false },
    }
  );
  const [medicareExtraDetailsList, setMedicareExtraDetailsList] = useState<
    DocumentData[] | null
  >(null);

  async function updateFaxTrackingDB(timestamp: string, medName: string) {
    if (!userData) return;
    const userDocRef = doc(db, 'clients', userData.ssn.toString());
    const ordersRef = collection(userDocRef, 'orders');
    const q = query(
      ordersRef,
      where('timestamp', '==', timestamp) &&
        where('medicationName', '==', medName)
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach(async (doc) => {
      await updateDoc(doc.ref, {
        faxSent: new Date().toISOString(),
      });
    });
    nextStep();
  }
  const Step1Screen1 = () => (
    <>
      <div className="step-title">Initial Steps</div>

      <Stack
        className="tprx-card"
        style={{ maxWidth: '93rem', margin: '0 auto' }}>
        <svg
          width="50"
          height="51"
          viewBox="0 0 50 51"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.96565 9.47217H2.75168C1.76032 9.47217 0.949219 10.2833 0.949219 11.2746V42.1432C0.949219 43.1345 1.76032 43.9457 2.75168 43.9457H47.2483C48.2397 43.9457 49.0508 43.1345 49.0508 42.1432V11.2746C49.0508 10.2833 48.2397 9.47217 47.2483 9.47217H41.0344"
            stroke="#143A60"
            strokeWidth="1.80246"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.96645 13.4797H4.95898V36.5692H45.0426V13.4797H41.0352M27.7628 43.9462C27.7628 43.9462 29.3404 48.6078 31.2639 49.5564H18.7377C20.6612 48.6078 22.2388 43.9462 22.2388 43.9462"
            stroke="#143A60"
            strokeWidth="1.80246"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24.9893 40.2651H25.0113"
            stroke="#066890"
            strokeWidth="2.70369"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M41.0343 36.5682V1.55762H8.9668V36.5682"
            stroke="#143A60"
            strokeWidth="1.80246"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30.9263 11.0801V14.8677H26.894V18.8999H23.1056V14.8677H19.0742V11.0801H23.1056V7.04785H26.894V11.0801H30.9263Z"
            stroke="#066890"
            strokeWidth="1.80246"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.2393 26.7087H31.7622M18.2393 31.4653H31.7622"
            stroke="#143A60"
            strokeWidth="1.80246"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <h2 className="text-center">Email Confirmation</h2>
        <p className="step-text">
          Have you received the "Next Steps" email with your application as a
          PDF attachment for each medication requested? Note: It generally takes
          72hours (3 business days) to arrive
        </p>
        <Button
          variant="contained"
          onClick={nextStep}
          endIcon={
            <svg
              width="15"
              height="9"
              viewBox="0 0 15 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.976055 4.987V3.664H11.7131L8.94106 0.891999L9.76006 0.0729996L14.0171 4.33L9.76006 8.587L8.94106 7.768L11.7221 4.987H0.976055Z"
                fill="currentColor"
              />
            </svg>
          }>
          Yes, Email Recieved
        </Button>
      </Stack>
    </>
  );
  const Step1Screen2 = () => (
    <>
      <div className="step-title">Initial Steps</div>
      <Stack
        className="tprx-card"
        style={{ maxWidth: '93rem', margin: '0 auto' }}>
        <svg
          width="48"
          height="49"
          viewBox="0 0 48 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1073_15)">
            <path
              d="M40.6278 13.1605L28.6285 1.16123C28.2857 0.818391 27.9428 0.646973 27.4286 0.646973H10.2868C8.40116 0.646973 6.8584 2.18974 6.8584 4.07533V45.2157C6.8584 47.1013 8.40116 48.644 10.2868 48.644H37.7137C39.5993 48.644 41.142 47.1013 41.142 45.2157V14.3604C41.142 13.8462 40.9706 13.5033 40.6278 13.1605ZM27.4286 4.76101L37.028 14.3604H27.4286V4.76101ZM37.7137 45.2157H10.2868V4.07533H24.0002V14.3604C24.0002 16.246 25.543 17.7888 27.4286 17.7888H37.7137V45.2157Z"
              fill="#153B61"
            />
            <path
              d="M13.7148 34.9303H34.285V38.3587H13.7148V34.9303ZM13.7148 24.6453H34.285V28.0736H13.7148V24.6453Z"
              fill="#076890"
            />
          </g>
          <defs>
            <clipPath id="clip0_1073_15">
              <rect
                width="48.0059"
                height="48.0059"
                fill="white"
                transform="translate(-0.00292969 0.556152)"
              />
            </clipPath>
          </defs>
        </svg>

        <h2 className="text-center">Understanding Information:</h2>
        <p className="step-text">
          Have you read all the information provided on each PDF attachment from
          the “Next Steps” email?
        </p>
        <Button
          variant="contained"
          onClick={nextStep}
          endIcon={
            <svg
              width="15"
              height="9"
              viewBox="0 0 15 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.976055 4.987V3.664H11.7131L8.94106 0.891999L9.76006 0.0729996L14.0171 4.33L9.76006 8.587L8.94106 7.768L11.7221 4.987H0.976055Z"
                fill="currentColor"
              />
            </svg>
          }>
          Yes, I've Read and Understand
        </Button>
      </Stack>
    </>
  );
  const Step2Screen1 = () => (
    <>
      <div className="step-title">Preparation of Your Medication Request</div>
      <Stack
        className="tprx-card"
        style={{ maxWidth: '93rem', margin: '0 auto' }}>
        <svg
          width="48"
          height="49"
          viewBox="0 0 48 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1073_18)">
            <path
              d="M35.3991 14.6603V6.11136H12.602V14.6603H9.75237V3.26172H38.2488V14.6603H35.3991ZM40.0013 24.634C40.8087 24.634 41.486 24.3605 42.0331 23.8133C42.5802 23.2662 42.8529 22.5899 42.851 21.7844C42.8491 20.9789 42.5764 20.3016 42.0331 19.7526C41.4898 19.2036 40.8125 18.93 40.0013 18.9319C39.1901 18.9338 38.5138 19.2074 37.9724 19.7526C37.4309 20.2978 37.1574 20.9751 37.1517 21.7844C37.146 22.5937 37.4195 23.27 37.9724 23.8133C38.5252 24.3567 39.1996 24.6302 40.0013 24.634ZM35.3991 44.251V31.3193H12.602V44.251H35.3991ZM38.2488 47.1006H9.75237V35.702H-0.00195312V20.3596C-0.00195312 18.7448 0.546128 17.3912 1.64229 16.2988C2.73845 15.2065 4.09013 14.6593 5.69733 14.6574H42.3038C43.9186 14.6574 45.2722 15.2046 46.3646 16.2988C47.4569 17.3931 48.0031 18.7457 48.0031 20.3567V35.702H38.2488V47.1006ZM45.1535 32.8524V20.3596C45.1535 19.5522 44.8808 18.8749 44.3356 18.3278C43.7904 17.7806 43.1131 17.5071 42.3038 17.5071H5.69733C4.88993 17.5071 4.21362 17.7806 3.66838 18.3278C3.12315 18.8749 2.84959 19.5522 2.84769 20.3596V32.8524H9.75237V28.4696H38.2488V32.8524H45.1535Z"
              fill="#153B61"
            />
            <path
              d="M42.0329 23.8131C41.4858 24.3602 40.8085 24.6338 40.0011 24.6338C39.1994 24.63 38.525 24.3564 37.9722 23.8131C37.4193 23.2698 37.1458 22.5934 37.1515 21.7841C37.1572 20.9748 37.4307 20.2976 37.9722 19.7523C38.5136 19.2071 39.1899 18.9336 40.0011 18.9317C40.8123 18.9298 41.4896 19.2033 42.0329 19.7523C42.5762 20.3014 42.8488 20.9786 42.8507 21.7841C42.8526 22.5896 42.58 23.266 42.0329 23.8131Z"
              fill="#076890"
            />
          </g>
          <defs>
            <clipPath id="clip0_1073_18">
              <rect
                width="48.0059"
                height="48.0059"
                fill="white"
                transform="translate(-0.00292969 0.562012)"
              />
            </clipPath>
          </defs>
        </svg>

        <h2 className="text-center">Document Preparation:</h2>
        <p className="step-text">
          Have you Printed out and Wet Ink Signed the application in the yellow
          highlighted areas?
        </p>
        <Button
          variant="contained"
          onClick={() => {
            downloadApplications({
              email: userData!.email,
              ssn: userData!.ssn,
              brand: true,
              meds: applicationMeds,
            });
          }}
          sx={{ backgroundColor: '#076890', color: '#fff' }}
          endIcon={
            <svg
              width="15"
              height="9"
              viewBox="0 0 15 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.976055 4.987V3.664H11.7131L8.94106 0.891999L9.76006 0.0729996L14.0171 4.33L9.76006 8.587L8.94106 7.768L11.7221 4.987H0.976055Z"
                fill="currentColor"
              />
            </svg>
          }>
          Download application
        </Button>

        <Button
          variant="contained"
          onClick={nextStep}
          endIcon={
            <svg
              width="15"
              height="9"
              viewBox="0 0 15 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.976055 4.987V3.664H11.7131L8.94106 0.891999L9.76006 0.0729996L14.0171 4.33L9.76006 8.587L8.94106 7.768L11.7221 4.987H0.976055Z"
                fill="currentColor"
              />
            </svg>
          }>
          Yes, I’ve Signed
        </Button>
      </Stack>
    </>
  );
  const Step2Screen2 = () => (
    <>
      <div className="step-title">Preparation of Your Medication Request</div>
      <Stack
        className="tprx-card"
        style={{ maxWidth: '93rem', margin: '0 auto' }}>
        <svg
          width="48"
          height="49"
          viewBox="0 0 48 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1073_27)">
            <path
              d="M4.30786 45.9065C3.07928 45.9065 2.05428 45.4958 1.23285 44.6744C0.411427 43.853 -0.000175148 42.8271 -0.00195312 41.5967V7.54492C-0.00195312 6.31634 0.409649 5.29134 1.23285 4.46991C2.05606 3.64849 3.08017 3.23689 4.30519 3.23511H43.6963C44.9231 3.23511 45.9472 3.64671 46.7686 4.46991C47.59 5.29311 48.0016 6.31812 48.0034 7.54492V41.5994C48.0034 42.8262 47.5918 43.8512 46.7686 44.6744C45.9454 45.4976 44.9213 45.9083 43.6963 45.9065H4.30786ZM4.30786 43.2396H43.6963C44.1052 43.2396 44.4812 43.0689 44.8244 42.7275C45.1675 42.3862 45.3382 42.0092 45.3365 41.5967V7.54492C45.3365 7.13421 45.1658 6.75728 44.8244 6.41413C44.483 6.07098 44.107 5.90029 43.6963 5.90207H4.30519C3.89626 5.90207 3.52022 6.07276 3.17707 6.41413C2.83392 6.7555 2.66323 7.13243 2.66501 7.54492V41.5994C2.66501 42.0083 2.8357 42.3844 3.17707 42.7275C3.51844 43.0707 3.89448 43.2414 4.30519 43.2396M6.66546 36.5722H17.3333V33.9052H6.66546V36.5722ZM30.8015 30.6755L42.1041 19.3702L40.2025 17.466L30.8015 26.9338L27.0011 23.136L25.1662 25.0375L30.8015 30.6755ZM6.66546 25.9043H17.3333V23.2373H6.66546V25.9043ZM6.66546 15.2365H17.3333V12.5695H6.66546V15.2365Z"
              fill="#153B61"
            />
            <path
              d="M42.1029 19.3703L30.8003 30.6755L25.165 25.0376L26.9999 23.136L30.8003 26.9338L40.2014 17.4661L42.1029 19.3703Z"
              fill="#076890"
            />
          </g>
          <defs>
            <clipPath id="clip0_1073_27">
              <rect
                width="48.0059"
                height="48.0059"
                fill="white"
                transform="translate(-0.00292969 0.567871)"
              />
            </clipPath>
          </defs>
        </svg>

        <h2 className="text-center">Income Verification:</h2>
        <p className="step-text">
          Attach your last 2 months Social Security Checks Or a copy of your
          social security award letter you received at the beginning of each
          year
        </p>
        {userData &&
          (userData.medicare.partD === 'yes' ||
            userData.medicare.advantage === 'yes') && (
            <>
              <h2 className="text-center">Copy of Medicare Card</h2>
              <p className="step-text">
                Copy of Medicare prescription drug coverage card (PART D):
                attach a copy of both the front and back of your Medicare
                prescription drug coverage card. (NOT ORIGINAL CARD)
              </p>
            </>
          )}
        {clientExtraDetails.length > 0 && (
          <>
            <h2 className="text-center"> Special Requirements </h2>
            {clientExtraDetails.map((requirement) => (
              <p className="step-text">
                <strong>{requirement.medicationName}</strong>:{' '}
                {requirement.details}
              </p>
            ))}
          </>
        )}

        <Button
          variant="contained"
          onClick={nextStep}
          endIcon={
            <svg
              width="15"
              height="9"
              viewBox="0 0 15 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.976055 4.987V3.664H11.7131L8.94106 0.891999L9.76006 0.0729996L14.0171 4.33L9.76006 8.587L8.94106 7.768L11.7221 4.987H0.976055Z"
                fill="currentColor"
              />
            </svg>
          }>
          Yes, Printed & Attached
        </Button>
      </Stack>
    </>
  );
  const Step3Screen1 = () => (
    <>
      <div className="step-title">Submission of Your Medication Request</div>
      <Stack
        className="tprx-card"
        style={{ maxWidth: '93rem', margin: '0 auto' }}>
        <svg
          width="48"
          height="49"
          viewBox="0 0 48 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1074_30)">
            <path
              d="M47.2 0.567871H15.2C14.7582 0.567871 14.4 0.926071 14.4 1.36787V14.9679H11.12C8.9024 14.965 6.7989 15.9504 5.3816 17.6559C4.2694 18.9937 2.6198 19.7677 0.88 19.7679H0V21.3679H0.88C3.0976 21.3708 5.2011 20.3854 6.6184 18.6799C7.7315 17.341 9.3828 16.567 11.124 16.5679H14.2952L24.472 19.2823C25.2827 19.5001 25.7634 20.3339 25.5456 21.1446C25.4593 21.466 25.2698 21.7502 25.0064 21.9535C24.6333 22.2435 24.1456 22.3412 23.6896 22.2175L14.6064 19.7951C14.2393 19.6969 13.8538 19.8704 13.684 20.2103L13.0192 21.5399C12.097 23.4008 10.1968 24.5752 8.12 24.5679H6.4V26.1679H8.12C10.7665 26.1755 13.1932 24.6969 14.4 22.3415V37.3679H12.24C10.3394 37.3657 8.5563 36.4482 7.4496 34.9031C6.0434 32.938 3.7764 31.7708 1.36 31.7679H0V33.3679H1.36C3.2606 33.3701 5.0437 34.2876 6.1504 35.8327C7.5566 37.7978 9.8236 38.965 12.24 38.9679H14.4V47.7679C14.4 48.2097 14.7582 48.5679 15.2 48.5679H47.2C47.6418 48.5679 48 48.2097 48 47.7679V1.36787C48 0.926071 47.6418 0.567871 47.2 0.567871ZM46.4 46.9679H16V21.8223L23.28 23.7631C24.9455 24.2049 26.6539 23.2129 27.0957 21.5474C27.1648 21.287 27.1998 21.0188 27.2 20.7495C27.1996 19.3366 26.2499 18.1003 24.8848 17.7359L16 15.3679V2.16787H46.4V46.9679Z"
              fill="#153B61"
            />
            <path
              d="M39.2002 4.56787H23.2002V6.16787H39.2002V4.56787Z"
              fill="#076890"
            />
            <path
              d="M28.0002 14.168H23.2002V15.768H28.0002V14.168Z"
              fill="#076890"
            />
            <path
              d="M38.3996 14.168H29.5996V15.768H38.3996V14.168Z"
              fill="#076890"
            />
            <path d="M36 18.168H28V19.768H36V18.168Z" fill="#076890" />
            <path d="M42.4 22.168H28V23.768H42.4V22.168Z" fill="#076890" />
            <path d="M42.4 26.168H20V27.768H42.4V26.168Z" fill="#076890" />
            <path d="M42.4 14.168H40V15.768H42.4V14.168Z" fill="#076890" />
            <path
              d="M42.3996 18.168H37.5996V19.768H42.3996V18.168Z"
              fill="#076890"
            />
            <path d="M36 30.168H20V31.768H36V30.168Z" fill="#076890" />
            <path d="M42.4 34.168H20V35.768H42.4V34.168Z" fill="#076890" />
            <path d="M24.8 38.168H20V39.768H24.8V38.168Z" fill="#076890" />
            <path
              d="M42.4004 38.168H26.4004V39.768H42.4004V38.168Z"
              fill="#076890"
            />
            <path
              d="M42.3996 30.168H37.5996V31.768H42.3996V30.168Z"
              fill="#076890"
            />
            <path d="M42.4 10.168H20V11.768H42.4V10.168Z" fill="#076890" />
          </g>
          <defs>
            <clipPath id="clip0_1074_30">
              <rect
                width="48"
                height="48"
                fill="white"
                transform="translate(0 0.567871)"
              />
            </clipPath>
          </defs>
        </svg>

        <h2 className="text-center">Hand-Delivery to Healthcare Provider: :</h2>
        <p className="step-text">
          Have you hand-delivered or mailed the physical signed application and
          income verification to your healthcare provider?
        </p>

        <Button
          variant="contained"
          onClick={nextStep}
          endIcon={
            <svg
              width="15"
              height="9"
              viewBox="0 0 15 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.976055 4.987V3.664H11.7131L8.94106 0.891999L9.76006 0.0729996L14.0171 4.33L9.76006 8.587L8.94106 7.768L11.7221 4.987H0.976055Z"
                fill="currentColor"
              />
            </svg>
          }>
          Yes, Delivered
        </Button>
      </Stack>
    </>
  );
  const Step3Screen2 = () => (
    <>
      <div className="step-title">Submission of Your Medication Request</div>
      <Stack
        className="tprx-card"
        style={{ maxWidth: '93rem', margin: '0 auto' }}>
        <svg
          width="48"
          height="49"
          viewBox="0 0 48 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1074_64)">
            <path
              d="M26.4 24.5679C25.0745 24.5679 24 25.6424 24 26.9679C24 28.2934 25.0745 29.3679 26.4 29.3679C27.7255 29.3679 28.8 28.2934 28.8 26.9679C28.8 25.6424 27.7255 24.5679 26.4 24.5679ZM26.4 27.7679C25.9582 27.7679 25.6 27.4097 25.6 26.9679C25.6 26.5261 25.9582 26.1679 26.4 26.1679C26.8418 26.1679 27.2 26.5261 27.2 26.9679C27.2 27.4097 26.8418 27.7679 26.4 27.7679Z"
              fill="#076890"
            />
            <path
              d="M32.8004 24.5679C31.4749 24.5679 30.4004 25.6424 30.4004 26.9679C30.4004 28.2934 31.4749 29.3679 32.8004 29.3679C34.1259 29.3679 35.2004 28.2934 35.2004 26.9679C35.2004 25.6424 34.1259 24.5679 32.8004 24.5679ZM32.8004 27.7679C32.3586 27.7679 32.0004 27.4097 32.0004 26.9679C32.0004 26.5261 32.3586 26.1679 32.8004 26.1679C33.2422 26.1679 33.6004 26.5261 33.6004 26.9679C33.6004 27.4097 33.2422 27.7679 32.8004 27.7679Z"
              fill="#076890"
            />
            <path
              d="M39.1998 24.5679C37.8743 24.5679 36.7998 25.6424 36.7998 26.9679C36.7998 28.2934 37.8743 29.3679 39.1998 29.3679C40.5253 29.3679 41.5998 28.2934 41.5998 26.9679C41.5998 25.6424 40.5253 24.5679 39.1998 24.5679ZM39.1998 27.7679C38.758 27.7679 38.3998 27.4097 38.3998 26.9679C38.3998 26.5261 38.758 26.1679 39.1998 26.1679C39.6416 26.1679 39.9998 26.5261 39.9998 26.9679C39.9998 27.4097 39.6416 27.7679 39.1998 27.7679Z"
              fill="#076890"
            />
            <path
              d="M26.4 30.9678C25.0745 30.9678 24 32.0423 24 33.3678C24 34.6933 25.0745 35.7678 26.4 35.7678C27.7255 35.7678 28.8 34.6933 28.8 33.3678C28.8 32.0423 27.7255 30.9678 26.4 30.9678ZM26.4 34.1678C25.9582 34.1678 25.6 33.8096 25.6 33.3678C25.6 32.926 25.9582 32.5678 26.4 32.5678C26.8418 32.5678 27.2 32.926 27.2 33.3678C27.2 33.8096 26.8418 34.1678 26.4 34.1678Z"
              fill="#076890"
            />
            <path
              d="M32.8004 30.9678C31.4749 30.9678 30.4004 32.0423 30.4004 33.3678C30.4004 34.6933 31.4749 35.7678 32.8004 35.7678C34.1259 35.7678 35.2004 34.6933 35.2004 33.3678C35.2004 32.0423 34.1259 30.9678 32.8004 30.9678ZM32.8004 34.1678C32.3586 34.1678 32.0004 33.8096 32.0004 33.3678C32.0004 32.926 32.3586 32.5678 32.8004 32.5678C33.2422 32.5678 33.6004 32.926 33.6004 33.3678C33.6004 33.8096 33.2422 34.1678 32.8004 34.1678Z"
              fill="#076890"
            />
            <path
              d="M39.1998 30.9678C37.8743 30.9678 36.7998 32.0423 36.7998 33.3678C36.7998 34.6933 37.8743 35.7678 39.1998 35.7678C40.5253 35.7678 41.5998 34.6933 41.5998 33.3678C41.5998 32.0423 40.5253 30.9678 39.1998 30.9678ZM39.1998 34.1678C38.758 34.1678 38.3998 33.8096 38.3998 33.3678C38.3998 32.926 38.758 32.5678 39.1998 32.5678C39.6416 32.5678 39.9998 32.926 39.9998 33.3678C39.9998 33.8096 39.6416 34.1678 39.1998 34.1678Z"
              fill="#076890"
            />
            <path
              d="M26.4 37.3679C25.0745 37.3679 24 38.4424 24 39.7679C24 41.0934 25.0745 42.1679 26.4 42.1679C27.7255 42.1679 28.8 41.0934 28.8 39.7679C28.8 38.4424 27.7255 37.3679 26.4 37.3679ZM26.4 40.5679C25.9582 40.5679 25.6 40.2097 25.6 39.7679C25.6 39.3261 25.9582 38.9679 26.4 38.9679C26.8418 38.9679 27.2 39.3261 27.2 39.7679C27.2 40.2097 26.8418 40.5679 26.4 40.5679Z"
              fill="#076890"
            />
            <path
              d="M32.8004 37.3679C31.4749 37.3679 30.4004 38.4424 30.4004 39.7679C30.4004 41.0934 31.4749 42.1679 32.8004 42.1679C34.1259 42.1679 35.2004 41.0934 35.2004 39.7679C35.2004 38.4424 34.1259 37.3679 32.8004 37.3679ZM32.8004 40.5679C32.3586 40.5679 32.0004 40.2097 32.0004 39.7679C32.0004 39.3261 32.3586 38.9679 32.8004 38.9679C33.2422 38.9679 33.6004 39.3261 33.6004 39.7679C33.6004 40.2097 33.2422 40.5679 32.8004 40.5679Z"
              fill="#076890"
            />
            <path
              d="M39.1998 37.3679C37.8743 37.3679 36.7998 38.4424 36.7998 39.7679C36.7998 41.0934 37.8743 42.1679 39.1998 42.1679C40.5253 42.1679 41.5998 41.0934 41.5998 39.7679C41.5998 38.4424 40.5253 37.3679 39.1998 37.3679ZM39.1998 40.5679C38.758 40.5679 38.3998 40.2097 38.3998 39.7679C38.3998 39.3261 38.758 38.9679 39.1998 38.9679C39.6416 38.9679 39.9998 39.3261 39.9998 39.7679C39.9998 40.2097 39.6416 40.5679 39.1998 40.5679Z"
              fill="#076890"
            />
            <path
              d="M45.6 13.3679H42.4V4.25507L38.72 0.567871H23.2V13.3679H17.36C16.6508 10.9985 14.4732 9.37337 12 9.36787H10.4C7.9268 9.37337 5.7492 10.9985 5.04 13.3679H2.4C1.0745 13.3679 0 14.4424 0 15.7679V42.9679C0 44.2934 1.0745 45.3679 2.4 45.3679H5.348C6.2738 47.3197 8.2397 48.5649 10.4 48.5679H12C14.1603 48.5649 16.1262 47.3197 17.052 45.3679H45.6C46.9255 45.3679 48 44.2934 48 42.9679V15.7679C48 14.4424 46.9255 13.3679 45.6 13.3679ZM2.4 43.7679C1.9582 43.7679 1.6 43.4097 1.6 42.9679V15.7679C1.6 15.3261 1.9582 14.9679 2.4 14.9679H4.8V42.9679C4.8022 43.2357 4.8236 43.5031 4.864 43.7679H2.4ZM16 42.9679C15.9974 45.1759 14.208 46.9653 12 46.9679H10.4C8.192 46.9653 6.4026 45.1759 6.4 42.9679V14.9679C6.4026 12.7599 8.192 10.9705 10.4 10.9679H12C14.208 10.9705 15.9974 12.7599 16 14.9679V42.9679ZM24.8 2.16787H38.0584L40.8 4.91667V13.3679H24.8V2.16787ZM46.4 42.9679C46.4 43.4097 46.0418 43.7679 45.6 43.7679H17.536C17.5764 43.5031 17.5978 43.2357 17.6 42.9679V14.9679H45.6C46.0418 14.9679 46.4 15.3261 46.4 15.7679V42.9679Z"
              fill="#153B61"
            />
            <path
              d="M23.2002 16.5679V22.9679H42.4002V16.5679H23.2002ZM40.8002 21.3679H24.8002V18.1679H40.8002V21.3679Z"
              fill="#076890"
            />
            <path
              d="M37.6004 3.76782H26.4004V5.36782H37.6004V3.76782Z"
              fill="#076890"
            />
            <path
              d="M37.6004 6.96777H26.4004V8.56777H37.6004V6.96777Z"
              fill="#076890"
            />
            <path
              d="M37.6004 10.168H26.4004V11.768H37.6004V10.168Z"
              fill="#076890"
            />
          </g>
          <defs>
            <clipPath id="clip0_1074_64">
              <rect
                width="48"
                height="48"
                fill="white"
                transform="translate(0 0.567871)"
              />
            </clipPath>
          </defs>
        </svg>

        <h2 className="text-center">Healthcare Provider Fax Confirmation:</h2>
        <p className="step-text">
          Have you confirmed with your healthcare provider that they have faxed
          your application directly to the Manufacturer, not to us?
        </p>

        <Button
          variant="contained"
          onClick={nextStep}
          endIcon={
            <svg
              width="15"
              height="9"
              viewBox="0 0 15 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.976055 4.987V3.664H11.7131L8.94106 0.891999L9.76006 0.0729996L14.0171 4.33L9.76006 8.587L8.94106 7.768L11.7221 4.987H0.976055Z"
                fill="currentColor"
              />
            </svg>
          }>
          Yes, Confirmed
        </Button>
      </Stack>
    </>
  );
  const Step4Screen1 = () => (
    <>
      <div className="step-title">Steps for Tracking Your Medication</div>
      <Stack
        className="tprx-card"
        style={{ maxWidth: '93rem', margin: '0 auto' }}>
        <svg
          width="48"
          height="49"
          viewBox="0 0 48 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1074_122)">
            <path
              d="M35.1628 28.9808C35.7549 28.9808 36.3228 28.7456 36.7415 28.3269C37.1602 27.9082 37.3954 27.3403 37.3954 26.7482C37.3954 26.1561 37.1602 25.5882 36.7415 25.1695C36.3228 24.7508 35.7549 24.5156 35.1628 24.5156C34.5707 24.5156 34.0028 24.7508 33.5841 25.1695C33.1654 25.5882 32.9302 26.1561 32.9302 26.7482C32.9302 27.3403 33.1654 27.9082 33.5841 28.3269C34.0028 28.7456 34.5707 28.9808 35.1628 28.9808ZM35.1628 37.9111C35.7549 37.9111 36.3228 37.6758 36.7415 37.2572C37.1602 36.8385 37.3954 36.2706 37.3954 35.6785C37.3954 35.0864 37.1602 34.5185 36.7415 34.0998C36.3228 33.6811 35.7549 33.4459 35.1628 33.4459C34.5707 33.4459 34.0028 33.6811 33.5841 34.0998C33.1654 34.5185 32.9302 35.0864 32.9302 35.6785C32.9302 36.2706 33.1654 36.8385 33.5841 37.2572C34.0028 37.6758 34.5707 37.9111 35.1628 37.9111ZM26.2325 26.7482C26.2325 27.3403 25.9973 27.9082 25.5786 28.3269C25.1599 28.7456 24.592 28.9808 23.9999 28.9808C23.4078 28.9808 22.84 28.7456 22.4213 28.3269C22.0026 27.9082 21.7674 27.3403 21.7674 26.7482C21.7674 26.1561 22.0026 25.5882 22.4213 25.1695C22.84 24.7508 23.4078 24.5156 23.9999 24.5156C24.592 24.5156 25.1599 24.7508 25.5786 25.1695C25.9973 25.5882 26.2325 26.1561 26.2325 26.7482ZM26.2325 35.6785C26.2325 36.2706 25.9973 36.8385 25.5786 37.2572C25.1599 37.6758 24.592 37.9111 23.9999 37.9111C23.4078 37.9111 22.84 37.6758 22.4213 37.2572C22.0026 36.8385 21.7674 36.2706 21.7674 35.6785C21.7674 35.0864 22.0026 34.5185 22.4213 34.0998C22.84 33.6811 23.4078 33.4459 23.9999 33.4459C24.592 33.4459 25.1599 33.6811 25.5786 34.0998C25.9973 34.5185 26.2325 35.0864 26.2325 35.6785ZM12.8371 28.9808C13.4292 28.9808 13.997 28.7456 14.4157 28.3269C14.8344 27.9082 15.0696 27.3403 15.0696 26.7482C15.0696 26.1561 14.8344 25.5882 14.4157 25.1695C13.997 24.7508 13.4292 24.5156 12.8371 24.5156C12.245 24.5156 11.6771 24.7508 11.2584 25.1695C10.8397 25.5882 10.6045 26.1561 10.6045 26.7482C10.6045 27.3403 10.8397 27.9082 11.2584 28.3269C11.6771 28.7456 12.245 28.9808 12.8371 28.9808ZM12.8371 37.9111C13.4292 37.9111 13.997 37.6758 14.4157 37.2572C14.8344 36.8385 15.0696 36.2706 15.0696 35.6785C15.0696 35.0864 14.8344 34.5185 14.4157 34.0998C13.997 33.6811 13.4292 33.4459 12.8371 33.4459C12.245 33.4459 11.6771 33.6811 11.2584 34.0998C10.8397 34.5185 10.6045 35.0864 10.6045 35.6785C10.6045 36.2706 10.8397 36.8385 11.2584 37.2572C11.6771 37.6758 12.245 37.9111 12.8371 37.9111Z"
              fill="#076890"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.837 1.63159C13.2811 1.63159 13.707 1.808 14.021 2.12202C14.335 2.43604 14.5114 2.86194 14.5114 3.30602V5.00948C15.9894 4.98045 17.617 4.98045 19.4075 4.98045H28.5901C30.3828 4.98045 32.0104 4.98045 33.4883 5.00948V3.30602C33.4883 2.86194 33.6647 2.43604 33.9787 2.12202C34.2928 1.808 34.7187 1.63159 35.1627 1.63159C35.6068 1.63159 36.0327 1.808 36.3468 2.12202C36.6608 2.43604 36.8372 2.86194 36.8372 3.30602V5.15236C37.4176 5.19701 37.9669 5.25283 38.4871 5.32204C41.1036 5.67478 43.2223 6.416 44.8945 8.08596C46.5645 9.75816 47.3057 11.8769 47.6585 14.4934C48 17.0386 48 20.287 48 24.3904V29.1056C48 33.2091 48 36.4597 47.6585 39.0026C47.3057 41.6192 46.5645 43.7379 44.8945 45.4101C43.2223 47.0801 41.1036 47.8213 38.4871 48.174C35.9419 48.5156 32.6935 48.5156 28.5901 48.5156H19.4119C15.3085 48.5156 12.0578 48.5156 9.51495 48.174C6.89837 47.8213 4.77966 47.0801 3.10746 45.4101C1.4375 43.7379 0.696283 41.6192 0.343537 39.0026C0.00195312 36.4575 0.00195312 33.2091 0.00195312 29.1056V24.3904C0.00195312 20.287 0.00195312 17.0363 0.343537 14.4934C0.696283 11.8769 1.4375 9.75816 3.10746 8.08596C4.77966 6.416 6.89837 5.67478 9.51495 5.32204C10.0351 5.25283 10.5866 5.19701 11.1648 5.15236V3.30602C11.1648 2.86232 11.3409 2.43676 11.6545 2.12281C11.968 1.80886 12.3933 1.63218 12.837 1.63159ZM9.957 8.64187C7.71326 8.94327 6.41837 9.51034 5.47399 10.4547C4.52961 11.3991 3.96254 12.694 3.66114 14.94C3.60979 15.3195 3.56737 15.7214 3.53165 16.1433H44.4681C44.4324 15.7191 44.39 15.3195 44.3386 14.9377C44.0372 12.694 43.4702 11.3991 42.5258 10.4547C41.5814 9.51034 40.2865 8.94327 38.0405 8.64187C35.7477 8.33378 32.7225 8.32931 28.465 8.32931H19.5347C15.2772 8.32931 12.2543 8.33378 9.957 8.64187ZM3.34858 24.5155C3.34858 22.6089 3.34858 20.95 3.3776 19.4922H44.6222C44.6512 20.95 44.6512 22.6089 44.6512 24.5155V28.9806C44.6512 33.2381 44.6467 36.2633 44.3386 38.5584C44.0372 40.8021 43.4702 42.097 42.5258 43.0414C41.5814 43.9857 40.2865 44.5528 38.0405 44.8542C35.7477 45.1623 32.7225 45.1668 28.465 45.1668H19.5347C15.2772 45.1668 12.2543 45.1623 9.957 44.8542C7.71326 44.5528 6.41837 43.9857 5.47399 43.0414C4.52961 42.097 3.96254 40.8021 3.66114 38.5561C3.35305 36.2633 3.34858 33.2381 3.34858 28.9806V24.5155Z"
              fill="#153B61"
            />
          </g>
          <defs>
            <clipPath id="clip0_1074_122">
              <rect
                width="48"
                height="48"
                fill="white"
                transform="translate(0 0.57373)"
              />
            </clipPath>
          </defs>
        </svg>

        <h2 className="text-center">Waiting Period:</h2>
        <p className="step-text">
          Have 3 weeks passed since your healthcare provider eFaxed your
          medication request to the Manufacturer?
        </p>

        <Button
          variant="contained"
          onClick={nextStep}
          endIcon={
            <svg
              width="15"
              height="9"
              viewBox="0 0 15 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.976055 4.987V3.664H11.7131L8.94106 0.891999L9.76006 0.0729996L14.0171 4.33L9.76006 8.587L8.94106 7.768L11.7221 4.987H0.976055Z"
                fill="currentColor"
              />
            </svg>
          }>
          Yes, 3 Weeks Passed
        </Button>
      </Stack>
    </>
  );
  const Step4Screen2 = () => (
    <>
      <div className="step-title">Steps for Tracking Your Medication</div>
      <Stack
        className="tprx-card"
        style={{ maxWidth: '93rem', margin: '0 auto' }}>
        <svg
          width="48"
          height="49"
          viewBox="0 0 48 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1074_245)">
            <path
              d="M38.9008 26.0724H31.9348C31.4533 26.0724 31.0641 25.6832 31.0641 25.2017V17.9205H23.7829C23.3013 17.9205 22.9121 17.5304 22.9121 17.0497V10.0838C22.9121 9.60224 23.3013 9.21301 23.7829 9.21301H31.0641V1.93007C31.0641 1.44942 31.4533 1.05933 31.9348 1.05933H38.9008C39.3823 1.05933 39.7715 1.44942 39.7715 1.93007V9.21214H47.0536C47.5351 9.21214 47.9244 9.60137 47.9244 10.0829V17.0489C47.9244 17.5295 47.5351 17.9196 47.0536 17.9196H39.7715V25.2008C39.7715 25.6823 39.3814 26.0724 38.9008 26.0724ZM32.8056 24.3309H38.03V17.0497C38.03 16.5682 38.4193 16.179 38.9008 16.179H46.1829V10.9545H38.9008C38.4193 10.9545 38.03 10.5644 38.03 10.0838V2.80082H32.8056V10.0829C32.8056 10.5635 32.4163 10.9536 31.9348 10.9536H24.6536V16.1781H31.9348C32.4163 16.1781 32.8056 16.5674 32.8056 17.0489V24.3309Z"
              fill="#076890"
            />
            <path
              d="M20.5704 35.222C20.3553 35.222 20.1393 35.1428 19.9713 34.9834C15.9423 31.1556 12.7371 26.4004 10.7022 21.2308C10.5263 20.7832 10.7466 20.2773 11.1933 20.1015C11.64 19.9256 12.1459 20.145 12.3226 20.5926C14.2644 25.5271 17.3242 30.0663 21.1694 33.72C21.5177 34.0508 21.5325 34.6029 21.2008 34.9512C21.0301 35.1314 20.8011 35.222 20.5704 35.222Z"
              fill="#153B61"
            />
            <path
              d="M25.8254 47.8462C25.6913 47.8462 25.5537 47.8158 25.4266 47.7496C11.5181 40.5659 2.35523 26.9709 0.915883 11.3819C0.871475 10.903 1.22413 10.4798 1.70304 10.4354C2.18369 10.3849 2.60601 10.7437 2.65041 11.2217C4.0349 26.216 12.8477 39.292 26.2259 46.2014C26.6526 46.4226 26.8206 46.9476 26.6003 47.3752C26.4454 47.6747 26.1406 47.8462 25.8254 47.8462Z"
              fill="#153B61"
            />
            <path
              d="M1.78204 12.1736C1.33622 12.1736 0.957443 11.8341 0.915647 11.383C0.827701 10.4226 1.21431 9.47781 1.94835 8.85436C2.3132 8.54263 2.86438 8.58617 3.17524 8.95362C3.4861 9.32021 3.44256 9.86965 3.07597 10.1805C2.77295 10.4382 2.61448 10.8283 2.65105 11.2237C2.69459 11.7026 2.34193 12.1258 1.86302 12.1702C1.83516 12.1728 1.80816 12.1736 1.78204 12.1736Z"
              fill="#153B61"
            />
            <path
              d="M2.51469 10.3879C2.2674 10.3879 2.02272 10.2834 1.84944 10.0805C1.53858 9.71391 1.58299 9.16359 1.94957 8.85274C3.91398 7.18612 6.265 5.94182 8.74925 5.2548C9.20813 5.12768 9.6914 5.39761 9.82027 5.86172C9.94827 6.32495 9.67659 6.80474 9.21336 6.93274C6.97205 7.55271 4.84917 8.67597 3.07719 10.1798C2.91349 10.3199 2.71322 10.3879 2.51469 10.3879Z"
              fill="#153B61"
            />
            <path
              d="M11.4941 8.25004C11.1414 8.25004 10.8088 8.03323 10.6773 7.68319C10.4561 7.08585 9.82659 6.76455 9.2101 6.93434C8.75122 7.06147 8.26795 6.79154 8.13908 6.32743C8.01108 5.86419 8.28275 5.38441 8.74599 5.25641C10.2376 4.84455 11.7701 5.62648 12.31 7.07627C12.4771 7.52732 12.2481 8.028 11.7971 8.19606C11.6978 8.23176 11.5951 8.25004 11.4941 8.25004Z"
              fill="#153B61"
            />
            <path
              d="M26.7866 48.0798C26.3199 48.0798 25.8541 47.9701 25.4274 47.7498C25.0007 47.5295 24.8327 47.0044 25.053 46.5769C25.2733 46.1493 25.7957 45.9795 26.2267 46.2016C26.5777 46.3836 26.9991 46.3827 27.3517 46.1981C27.7784 45.9752 28.3035 46.1406 28.5273 46.5664C28.7502 46.9922 28.5856 47.519 28.1598 47.7419C27.7305 47.9666 27.2586 48.0798 26.7866 48.0798Z"
              fill="#153B61"
            />
            <path
              d="M27.7556 47.8422C27.4421 47.8422 27.1391 47.6724 26.9832 47.3755C26.7603 46.9497 26.9249 46.4229 27.3507 46.2C29.41 45.1211 31.2481 43.5756 32.664 41.7304C32.9557 41.3499 33.5016 41.2768 33.8839 41.5694C34.2653 41.8628 34.3375 42.4096 34.045 42.7901C32.4768 44.8347 30.4409 46.5457 28.1587 47.7421C28.029 47.8091 27.8914 47.8422 27.7556 47.8422Z"
              fill="#153B61"
            />
            <path
              d="M33.3522 43.1313C33.1676 43.1313 32.9804 43.073 32.8236 42.9511C32.4422 42.6585 32.37 42.1117 32.6625 41.7303C33.05 41.2252 32.9891 40.5191 32.5189 40.0889C32.1645 39.7641 32.1401 39.2138 32.4649 38.8594C32.7897 38.505 33.34 38.4798 33.6952 38.8046C34.8359 39.8495 34.9848 41.5631 34.0427 42.79C33.872 43.0146 33.6134 43.1313 33.3522 43.1313Z"
              fill="#153B61"
            />
            <path
              d="M33.1082 40.3178C32.8984 40.3178 32.6877 40.2421 32.5196 40.0888L26.1327 34.2391C25.8201 33.9535 25.376 33.8508 24.965 33.9683L20.8141 35.1865C20.3526 35.3249 19.8702 35.0576 19.7335 34.5961C19.5986 34.1346 19.8624 33.6505 20.3248 33.5155L24.4756 32.2973C25.4648 32.0074 26.5498 32.259 27.309 32.9539L33.6969 38.8044C34.0513 39.1292 34.0756 39.6804 33.7508 40.0348C33.5784 40.2229 33.3442 40.3178 33.1082 40.3178Z"
              fill="#153B61"
            />
            <path
              d="M11.5127 21.783C11.3229 21.783 11.1322 21.7212 10.9728 21.594C10.5958 21.2954 10.5322 20.7477 10.8318 20.3715L13.5189 16.9808C13.7818 16.6482 13.8533 16.1954 13.7052 15.7975L10.6802 7.68297C10.5122 7.23192 10.7403 6.73037 11.1914 6.56319C11.6415 6.39514 12.144 6.62414 12.3112 7.07519L15.337 15.1897C15.6966 16.1545 15.5225 17.256 14.8833 18.0632L12.1953 21.4539C12.0238 21.6698 11.7696 21.783 11.5127 21.783Z"
              fill="#153B61"
            />
          </g>
          <defs>
            <clipPath id="clip0_1074_245">
              <rect
                width="48"
                height="48"
                fill="white"
                transform="translate(0 0.57373)"
              />
            </clipPath>
          </defs>
        </svg>

        <h2 className="text-center">Contact Your Healthcare Provider:</h2>
        <p className="step-text">
          Please contact your healthcare provider; they are the ONLY authorized
          Individual to request an update on your current situation directly
          from the manufacturer. Remember, you will receive your medication
          directly from the manufacturer ensuring the best price.
        </p>
        <Button
          variant="contained"
          onClick={nextStep}
          endIcon={
            <svg
              width="15"
              height="9"
              viewBox="0 0 15 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.976055 4.987V3.664H11.7131L8.94106 0.891999L9.76006 0.0729996L14.0171 4.33L9.76006 8.587L8.94106 7.768L11.7221 4.987H0.976055Z"
                fill="currentColor"
              />
            </svg>
          }>
          My Healthcare Provider is not Helping
        </Button>
      </Stack>
    </>
  );
  const Step4Screen3 = () => (
    <>
      <div className="step-title">Steps for Tracking Your Medication</div>
      <Stack
        className="tprx-card"
        style={{ maxWidth: '93rem', margin: '0 auto' }}>
        <svg
          width="48"
          height="44"
          viewBox="0 0 48 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1074_282)">
            <path
              d="M38.4761 42.9762L28.2413 35.1345H7.00545C3.14267 35.1345 0 32.2349 0 28.6716V7.7656C0 4.20231 3.14267 1.30273 7.00545 1.30273H40.882C44.7901 1.30273 47.9696 4.20231 47.9696 7.7656V28.6716C47.9696 32.2349 44.7901 35.1345 40.882 35.1345H40.2577V42.0943C40.2577 42.301 40.1999 42.5036 40.0908 42.6792C39.9818 42.8548 39.8258 42.9964 39.6406 43.0881C39.4553 43.1798 39.2481 43.2179 39.0424 43.1982C38.8366 43.1784 38.6405 43.1015 38.4761 42.9762ZM7.00545 3.00183C4.07933 3.00183 1.6991 5.13897 1.6991 7.7656V28.6716C1.6991 31.2983 4.07933 33.4354 7.00545 33.4354H28.3665C28.658 33.4361 28.9413 33.5319 29.1733 33.7084L38.5586 40.8996V34.6906C38.5644 34.3526 38.7041 34.0306 38.9469 33.7953C39.1898 33.56 39.516 33.4306 39.8541 33.4354H40.882C43.8534 33.4354 46.2705 31.2983 46.2705 28.6716V7.7656C46.2705 5.13897 43.8534 3.00183 40.882 3.00183H7.00545Z"
              fill="#153B61"
            />
            <path
              d="M38.5741 12.7891H35.4882C35.3766 12.7891 35.2662 12.811 35.1631 12.8537C35.06 12.8964 34.9663 12.959 34.8874 13.0378C34.8085 13.1167 34.746 13.2104 34.7033 13.3135C34.6606 13.4166 34.6386 13.5271 34.6387 13.6386V22.7987C34.6387 23.024 34.7282 23.2401 34.8875 23.3994C35.0468 23.5587 35.2629 23.6482 35.4882 23.6482C35.7135 23.6482 35.9296 23.5587 36.0889 23.3994C36.2483 23.2401 36.3378 23.024 36.3378 22.7987V19.7987H38.5741C39.5036 19.7987 40.395 19.4294 41.0523 18.7722C41.7096 18.1149 42.0789 17.2234 42.0789 16.2939C42.0789 15.3643 41.7096 14.4729 41.0523 13.8156C40.395 13.1583 39.5036 12.7891 38.5741 12.7891ZM38.5741 18.0996H36.3378V14.4882H38.5741C39.053 14.4882 39.5122 14.6784 39.8509 15.0171C40.1895 15.3557 40.3798 15.815 40.3798 16.2939C40.3798 16.7728 40.1895 17.2321 39.8509 17.5707C39.5122 17.9094 39.053 18.0996 38.5741 18.0996Z"
              fill="#076890"
            />
            <path
              d="M31.6549 23.6482H26.2578C26.1462 23.6482 26.0357 23.6263 25.9326 23.5836C25.8295 23.5409 25.7359 23.4783 25.657 23.3994C25.5781 23.3205 25.5155 23.2269 25.4728 23.1238C25.4301 23.0207 25.4082 22.9102 25.4082 22.7986V13.6386C25.4082 13.4133 25.4977 13.1972 25.657 13.0379C25.8164 12.8786 26.0324 12.7891 26.2578 12.7891C26.4831 12.7891 26.6992 12.8786 26.8585 13.0379C27.0178 13.1972 27.1073 13.4133 27.1073 13.6386V21.9491H31.6549C31.8802 21.9491 32.0963 22.0386 32.2557 22.1979C32.415 22.3572 32.5045 22.5733 32.5045 22.7986C32.5045 23.0239 32.415 23.24 32.2557 23.3993C32.0963 23.5587 31.8802 23.6482 31.6549 23.6482Z"
              fill="#076890"
            />
            <path
              d="M22.4261 21.9491H17.6698V19.0686H20.7444C20.9697 19.0686 21.1858 18.9791 21.3451 18.8198C21.5045 18.6604 21.594 18.4443 21.594 18.219C21.594 17.9937 21.5045 17.7776 21.3451 17.6183C21.1858 17.459 20.9697 17.3695 20.7444 17.3695H17.6698V14.4882H22.4261C22.6514 14.4882 22.8675 14.3987 23.0268 14.2393C23.1862 14.08 23.2757 13.8639 23.2757 13.6386C23.2757 13.4133 23.1862 13.1972 23.0268 13.0379C22.8675 12.8786 22.6514 12.7891 22.4261 12.7891H16.8203C16.7087 12.789 16.5982 12.811 16.4951 12.8537C16.392 12.8964 16.2984 12.9589 16.2195 13.0378C16.1406 13.1167 16.078 13.2104 16.0353 13.3135C15.9926 13.4166 15.9707 13.527 15.9707 13.6386V22.7986C15.9707 22.9102 15.9926 23.0207 16.0353 23.1238C16.078 23.2268 16.1406 23.3205 16.2195 23.3994C16.2984 23.4783 16.392 23.5409 16.4951 23.5835C16.5982 23.6262 16.7087 23.6482 16.8203 23.6482H22.4261C22.6514 23.6482 22.8675 23.5587 23.0268 23.3993C23.1862 23.24 23.2757 23.0239 23.2757 22.7986C23.2757 22.5733 23.1862 22.3572 23.0268 22.1979C22.8675 22.0386 22.6514 21.9491 22.4261 21.9491Z"
              fill="#076890"
            />
            <path
              d="M12.1386 13.6386V17.3695H7.58972V13.6386C7.58972 13.4133 7.50022 13.1972 7.34089 13.0379C7.18157 12.8786 6.96549 12.7891 6.74017 12.7891C6.51486 12.7891 6.29877 12.8786 6.13945 13.0379C5.98013 13.1972 5.89062 13.4133 5.89062 13.6386V22.7986C5.89062 23.0239 5.98013 23.24 6.13945 23.3993C6.29877 23.5587 6.51486 23.6482 6.74017 23.6482C6.96549 23.6482 7.18157 23.5587 7.34089 23.3993C7.50022 23.24 7.58972 23.0239 7.58972 22.7986V19.0686H12.1386V22.7986C12.1386 23.0239 12.2281 23.24 12.3874 23.3993C12.5468 23.5587 12.7629 23.6482 12.9882 23.6482C13.2135 23.6482 13.4296 23.5587 13.5889 23.3993C13.7482 23.24 13.8377 23.0239 13.8377 22.7986V13.6386C13.8377 13.4133 13.7482 13.1972 13.5889 13.0379C13.4296 12.8786 13.2135 12.7891 12.9882 12.7891C12.7629 12.7891 12.5468 12.8786 12.3874 13.0379C12.2281 13.1972 12.1386 13.4133 12.1386 13.6386Z"
              fill="#076890"
            />
          </g>
          <defs>
            <clipPath id="clip0_1074_282">
              <rect
                width="48"
                height="43"
                fill="white"
                transform="translate(0 0.57373)"
              />
            </clipPath>
          </defs>
        </svg>
        <h2 className="text-center">Request an Update:</h2>
        <p className="step-text">
          Do you want us to eFax again your healthcare provider with all the
          necessary information and guidance for them to request an update
          directly from the manufacturer?
        </p>
        <h3>
          Choose which medication should we eFax your healthcare provider a
          reminder:
        </h3>
        <Stack spacing={2} direction={'column'}>
          {ordersData?.map(
            (order) =>
              order.received === false &&
              medicationList?.find(
                (med) =>
                  med.name === order.medicationName.split(' (')[0] && med.brand
              ) && (
                <TrackingButton
                  key={order.medicationName}
                  orderTime={order.timestamp}
                  medicationName={order.medicationName}
                  sendFaxTracking={sendFaxTracking}
                  faxTrackingMeds={faxTrackingMeds}
                  onSuccess={updateFaxTrackingDB}
                  faxSent={order.faxSent}
                />
              )
          )}
        </Stack>
      </Stack>
    </>
  );
  const Step4Screen4 = () => (
    <>
      <div className="step-title">Steps for Tracking Your Medication</div>
      <Stack
        className="tprx-card"
        style={{ maxWidth: '93rem', margin: '0 auto' }}>
        <h2 className="text-center">
          Reminder sent to your healthcare provider
        </h2>
        <Button
          variant="contained"
          className="cta-main"
          onClick={() => {
            navigate('/');
          }}>
          Back to Home
        </Button>
        <Stack spacing={2} direction={'column'}></Stack>
      </Stack>
    </>
  );
  const nextStep = () => {
    if (step === 3) {
      // If it's the last step
      if (screen === 3) {
        // If it's the last screen of the last step
        setStep(step + 1);
        setScreen(0);
      } else {
        setScreen(screen + 1);
      }
    } else {
      if (screen === 1) {
        setStep(step + 1);
        setScreen(0);
      } else {
        setScreen(screen + 1);
      }
    }
  };
  useEffect(() => {
    if (!userData || !ordersData || !healthcareData) return;
    ordersData.map((order) => {
      if (order.received === false) {
        applicationMeds.push(order.medicationName);
        const faxTrackingData: faxTrackingData = {
          Patient_Name__c:
            userData.mname === ''
              ? userData.fname + ' ' + userData.lname
              : userData.fname + ' ' + userData.mname + ' ' + userData.lname,
          Patient_Email__c: userData.email,
          Medication_Name__c: order.medicationName,
          Doctor_Name__c: order.doctorName,
          Doctor_Fax__c: '',
        };
        healthcareData.map((doc: docInfo) => {
          if (
            doc.fname === order.doctorName.split(' ')[0] &&
            doc.lname === order.doctorName.split(' ').pop()
          ) {
            faxTrackingData.Doctor_Fax__c = doc.fax;
          }
        });
        faxTrackingMeds.push(faxTrackingData);
      }
    });
  }, [ordersData, applicationMeds, userData, healthcareData]);

  useEffect(() => {
    if (medicareExtraDetails && !loadingMedicareExtraDetails) {
      setMedicareExtraDetailsList(
        medicareExtraDetails.docs.map((doc) => doc.data())
      );
    }
  }, [loadingMedicareExtraDetails, medicareExtraDetails]);

  useEffect(() => {
    if (
      medicareExtraDetailsList &&
      medicareExtraDetailsList.length > 0 &&
      ordersData
    ) {
      const clientExtraDetails: { medicationName: string; details: string }[] =
        [];

      ordersData.forEach((order) => {
        const medName = order.medicationName.split(' (')[0];
        for (const requirement of medicareExtraDetailsList) {
          if (
            requirement.medications &&
            requirement.medications.includes(medName)
          ) {
            // Check if the medication details exist for the current medication name
            clientExtraDetails.push({
              medicationName: medName,
              details: requirement.emailText,
            });
          }
        }
        setClientExtraDetails(clientExtraDetails);
      });
    }
  }, [medicareExtraDetailsList, ordersData]);

  return (
    <Stack className="container">
      <button
        className="back-btn"
        onClick={() => {
          navigateWithQuery(navigate, '/', location);
        }}>
        <svg
          width="14"
          height="9"
          viewBox="0 0 14 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13.6049 5.18512H2.85895L5.63995 7.96612L4.82095 8.78512L0.563945 4.52812L4.82095 0.27112L5.63995 1.09012L2.86795 3.86212H13.6049V5.18512Z"
            fill="#191919"
          />
        </svg>
        Back
      </button>
      <Typography variant="h1" textAlign={'center'} mb={4}>
        Steps for Obtaining & Tracking your BRAND (No Cost) Medication
      </Typography>

      <Stack className="steps-w" direction={'row'}>
        <Stack className={`step ${step !== 0 ? 'disabled' : ''}`}>1</Stack>
        <Stack className={`step ${step !== 1 ? 'disabled' : ''}`}>2</Stack>
        <Stack className={`step ${step !== 2 ? 'disabled' : ''}`}>3</Stack>
        <Stack className={`step ${step !== 3 ? 'disabled' : ''}`}>4</Stack>
      </Stack>
      {step === 0 && screen === 0 && <Step1Screen1 />}
      {step === 0 && screen === 1 && <Step1Screen2 />}
      {step === 1 && screen === 0 && <Step2Screen1 />}
      {step === 1 && screen === 1 && <Step2Screen2 />}
      {step === 2 && screen === 0 && <Step3Screen1 />}
      {step === 2 && screen === 1 && <Step3Screen2 />}
      {step === 3 && screen === 0 && <Step4Screen1 />}
      {step === 3 && screen === 1 && <Step4Screen2 />}
      {step === 3 && screen === 2 && <Step4Screen3 />}
      {step === 3 && screen === 3 && <Step4Screen4 />}
    </Stack>
  );
}

export default BrandTracking;
